import React from 'react';
import Grid from '@mui/material/Grid2';

const MuiRow = ({ children, align_center, ...props }) => {

  if(align_center)
    props.sx={
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      ...props.sx,
    }

  return (
    <Grid container {...props}>
      {children}
    </Grid>
  );
};

export default MuiRow;